/** 前端轮询间隔（毫秒） */
export const POLL_INTERVALS = {
  approvalNotify: 20000,
  inbox: 20000
};
